import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderRailyTaxiRecalculate from "./billings-order-raily-taxi-recalculate";
import BillingsOrderRailyTaxiRecalculateParams from "./billings-order-raily-taxi-recalculate-params";

const useBillingsOrderRailyTaxiRecalculate = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderRailyTaxiRecalculate | null>(null);

  const load = async (
    params: BillingsOrderRailyTaxiRecalculateParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.recalculateOrderRailyTaxiBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderRailyTaxiRecalculate;
